module.exports = __webpack_public_path__ + "static/media/textureBanners.3c75d84c.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/textureBanners.jpg
 ** module id = 1627
 ** module chunks = 0
 **/